import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import Onboarding from '../features/onboarding/Onboarding'
import useDocumentTitle from '../hooks/useDocumentTitle';

const Home = () => {
    useDocumentTitle("Home");

    return (
        <>
            <Header />
            <Onboarding />
            <Footer />
        </>
    )
}

export default Home;